<template>
    <v-app id="inspire">
        <v-content style="background-color: #F5F5F5;" class="pt-0" >
            
            <div class="no-print" style="margin-top: 20px; margin-bottom: 10px; "><Breadcrumbs /></div>
            <v-container style="padding: 0px;" fluid >
            <div
                v-if="showTutorialButton"
                class="d-flex justify-end"
                style="margin-bottom: 10px;"
            >
                <v-btn
                    color="brand onBrand--text"
                    dark
                    small
                    style="margin-right:0.5em;border-radius:8px;"
                    @click="openTutorial"
                    class="no-display"
                >
                    <v-icon left> mdi-youtube</v-icon>
                    Watch Tutorial
                </v-btn>
            </div>
         <v-dialog v-model="videoDialog" max-width="1000px">
    <v-card>

        <v-card-title
            class="d-flex justify-space-between align-center grey lighten-4"
        >
            <span>{{ tutorialTitle }}</span>

            <v-btn
                icon
                @click="videoDialog = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pa-0">
            <v-responsive :aspect-ratio="16/9">

                <iframe
                    v-if="videoDialog && youtubeUrl"
                    width="100%"
                    height="100%"
                    :src="youtubeUrl"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                ></iframe>

            </v-responsive>
        </v-card-text>

    </v-card>
</v-dialog>
                <div class="tab-toggle-card no-display" v-if="load && filteredSortSearchList.length > 0">
                    <div class="tab-toggle-inner">
                        <label v-for="(link, index) in filteredSortSearchList" :key="index" class="tab-toggle"
                            :class="{ active: selectedTab === index }" @click="openLink(link.link, index)">
                            <v-avatar size="20" class="mr-2">
                                <v-img :src="link.icon" />
                            </v-avatar>
                            {{ link.name }}
                        </label>
                    </div>
                </div>

                <v-row>
                    <v-col cols="12" sm="12" md="12" class="pa-2">
                        <router-view ref="rv" />
                    </v-col>
                </v-row>
            </v-container>
   
        </v-content>
    </v-app>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import epsHeader from "../shared/UpdatedHeader";
import epsFooter from "../shared/Footer";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    props: {
        role_type: String,
        role_name: String,
    },
    data() {
        return {
            is_admin: false,
            data: {
                sblinks: [], // To store the sidebar links
            },
            selectedTab: 0,
            local_role_name:
    this.$route.query.role_name ||
    sessionStorage.getItem("para_role") ||
    "",

local_role_type:
    this.$route.query.role_type ||
    sessionStorage.getItem("para_role_type") ||
    "",
            local_role_name: this.$route.query.role_name || sessionStorage.getItem("para_role") || "",
            local_role_type: this.$route.query.role_type || sessionStorage.getItem("para_role_type") || "",
            tutorialTitle: "",
            youtubeUrl: "",
            videoDialog: false,
            youtubeUrl: "",
            tutorialTitle: "",
            videoDialog: false,
            selectedRole: null,
            userType: localStorage.getItem("EPS-ut") || "",
            currentTutorialModule: "",

            tutorials: {
                "Employee_AMC": {
                    title: "AMC Tutorial",
                    url: "https://www.youtube.com/embed/AMC_VIDEO_ID"
                },
                 "Employee_Accounting & Fees": {
                    title: "Accounting & Fees Tutorial",
                    url: "https://www.youtube.com/embed/Accounting&Fees_VIDEO_ID"
                },
                "Employee_Diary": {
                    title: "Diary Tutorial",
                    url: "https://www.youtube.com/embed/NbFlX5O7fYk?si=Gtig3r8GmmXU33f2"
                },
                 "Employee_Academics": {
                    title: "Academics Tutorial",
                    url: "https://www.youtube.com/embed/9FroDy4oMWM?si=RBq14kGHnVktFJN_"
                },
                 "Employee_Leave Management": {
                    title: "Leave Management Tutorial",
                    url: "https://www.youtube.com/embed/wzdyvDhMZnQ?si=kRxyD9f0KJQpzAgY"
                },
                 "Employee_Home Work": {
                    title: "Home Work Tutorial",
                    url: "https://www.youtube.com/embed/MUvk0HW00DQ?si=y4oKEbA7JqYjUvWD"
                },
                "Employee_Webinar": {
                    title: "Webinar Tutorial",
                    url: "https://www.youtube.com/embed/V15AAN3sxII?si=EI_OPJYDNIwnEzW4"
                },
                 "Employee_Canteen": {
                    title: "Canteen Tutorial",
                    url: "https://www.youtube.com/embed/hWRli7ZMqiI?si=2s6cYOtQx9nnqYl8"
                },
                "Employee_TimeTable": {
                    title: "Timetable Tutorial",
                    url: "https://www.youtube.com/embed/-pC29MzXLqI?si=n1a-G5g0Yj6Rvuyv"
                },
               
                 "Employee_Communication": {
                    title: "Communication Tutorial",
                    url: "https://www.youtube.com/embed/S-PJdLKVm1Q?si=6f_2AwGBDaWsCb88"
                },
                "Employee_Examination": {
                    title: "Examination Tutorial",
                    url: "https://www.youtube.com/embed/EcrDc658umo?si=NJQFAtfqsTyd2zuu"
                },
                "Employee_Pay Roll": {
                    title: "Pay Roll Tutorial",
                    url: "https://www.youtube.com/embed/cW9NTUn6QSs?si=JZEbJept5nBHUzTv"
                },
                "Employee_Quiz": {
                    title: "Quiz Tutorial",
                    url: "https://www.youtube.com/embed/Ew0knnmuRyg?si=PpKptHHWSCc0ft4A"
                },
                "Employee_Appointment": {
                    title: "Appointment Tutorial",
                    url: "https://www.youtube.com/embed/kld0OC8bYiM?si=Ufwg1w-my_Ecc1Hw"
                },
                "Employee_Timesheet": {
                    title: "Timesheet Tutorial",
                    url: "https://www.youtube.com/embed/NwgaSNYyz8E?si=b2tL-byxpPXnxSGQ"
                },
                "Parent_TimeTable": {
                    title: "TimeTable Tutorial",
                    url: "https://www.youtube.com/embed/SEQWbaTrPvo?si=RzVXBMxZHF5T5P80"
                },
                "Parent_Accounting & Fees": {
                    title: "Accounting & Fees Tutorial",
                    url: "https://www.youtube.com/embed/tQDQSV7odig?si=7N2nR6Lppw6Jaj8t"
                },
                "Parent_Examination": {
                    title: "Examination Tutorial",
                    url: "https://www.youtube.com/embed/JmcDpNGmDrA?si=GEoU91kVtstiFVFa"
                },
                 "Parent_Academics": {
                    title: "Academics Tutorial",
                    url: "https://www.youtube.com/embed/jp9PLcgFT68?si=3_PKwVQPSqMhgnTq"
                },
                "Parent_Communication": {
                    title: "Communication Tutorial",
                    url: "https://www.youtube.com/embed/3dHSngR2IHY?si=65y0Eyn4XTty49xx"
                },
                "Parent_EduStore": {
                    title: "EduStore Tutorial",
                    url: "https://www.youtube.com/embed/unREE0kXmvI?si=0IxEGiN5FBAbwrd1"
                },
                "Parent_Transportation": {
                    title: "Transportation Tutorial",
                    url: "https://www.youtube.com/embed/FVYR0anwu9A?si=X3vSJrhL5AJNUk2x"
                },
                "Parent_Canteen": {
                    title: "Canteen Tutorial",
                    url: "https://www.youtube.com/embed/BBMgi0lzsZ0?si=icZDMIRHKNKVknMr"
                },
                 "Parent_Home Work": {
                    title: "Home Work Tutorial",
                    url: "https://www.youtube.com/embed/mdQSq0gqqLw?si=FAVrBltscjPXZW2C"
                },
                "Parent_Suggestion/Query": {
                    title: "Suggestion/Query Tutorial",
                    url: "https://www.youtube.com/embed/_ZZn5nJRAEg?si=ZKGDJYizLxXyQhez"
                },
                //  "Parent_Worksheet": {
                //     title: "Worksheet Tutorial",
                //     url: "https://www.youtube.com/embed/WRaboc66Nyg?si=bAjpeP4hX9jyxhTt"
                // },
                 "Parent_Diary": {
                    title: "Diary Tutorial",
                    url: "https://www.youtube.com/embed/iEHUvjphAzE?si=BM9AsW3qydbqGceQ"
                },

            },
            emp_roles: [],
            parentUrl: "",
            isExactActive: true,
            search: "",
            load: false,
            isDrawer: false,
            items: [],
            activeLink: null, // To track the active link
            show_link_order: null,
            learner_standard:"",
            learner_board:"",
            learner_courses:[],
        };
    },
    computed: {
       
        filteredSortSearchList() {
            // Safety check: Ensure sblinks exists
            if (!this.data || !this.data.sblinks) {
                return [];
            }

           const restrictedWords = ["payroll", "pay roll", "pay slip", "Examination", "exam"];
            
            // Console logs to help us debug in the browser (F12 Developer Tools)
            console.log("Current User is Admin?", this.is_admin);
            console.log("Total Links Received from Backend:", this.data.sblinks.map(l => l.name));

            let allowedLinks = this.data.sblinks.filter(link => {
                if (!link.name) return false;

                const linkNameLower = link.name.toLowerCase().trim();
                const isRestricted = restrictedWords.some(word => linkNameLower.includes(word));
            
                if (this.is_admin === true && isRestricted) {
                    console.log("Hiding restricted link:", link.name);
                    return false; // This removes the link from the screen
                }
                
                return true; // Keep the link
            });

            // Apply your existing Sorting logic
            if (this.show_link_order === "Alphabet") {
                return allowedLinks.sort((a, b) => a.name.localeCompare(b.name));
            }

            // Apply your existing Search logic
            const safeSearch = this.search ? this.search.toLowerCase() : "";
            return allowedLinks.filter((tbdata) =>
                tbdata.name.toLowerCase().includes(safeSearch)
            );
        },
         
            currentModule() {

    if (this.$route.path === "/role-dashboard") {
        return this.local_role_type;
    }

    if (this.currentTutorialModule) {
        return this.currentTutorialModule;
    }

    const currentPath = this.$route.path;

    const currentLink = this.data.sblinks.find((link) => {

        const fullPath = this.parentUrl + link.link;

        return currentPath === fullPath ||
               currentPath.startsWith(fullPath + "/");

    });

    if (currentLink) {
        return currentLink.name;
    }

    return this.local_role_type;
},

//     showTutorialButton() {

//     const key = `${this.userType}_${this.currentModule}`;

//     console.log("Tutorial button key:", key);

//     return !!this.tutorials[key];
// },

    showTutorialButton() {
    // 1. Identify the modules where the button has special rules
    const hiddenModules = [
        "Pay Roll",
        "Payroll",
        "Pay Slip",
        "Examination",
        "Exam"
    ];

    const isHiddenModule = 
        hiddenModules.includes(this.currentModule) || 
        hiddenModules.includes(this.local_role_type);

    // 2. HIDE THE BUTTON ONLY IF THE USER IS AN ADMIN
    if (isHiddenModule && this.is_admin === true) {
        return false;
    }

    // 3. For Teachers/Parents, check if the tutorial video exists and show it
    const key = `${this.userType}_${this.currentModule}`;

    if (this.tutorials[key]) {
        return true;
    }

    return Object.keys(this.tutorials).some((tutKey) => tutKey.endsWith(`_${this.currentModule}`));
},

      
    },
    components: {
        epsHeader,
        epsFooter,
        Breadcrumbs,
    },
    methods: {
        syncDrawerState() {
            const storedValue = sessionStorage.getItem("isDrawer");
            const parsed = storedValue === null ? sessionStorage.getItem("isDrawer") : storedValue === "true";
            this.isDrawer = parsed;
        },
       openLink(linkPath, index) {

    this.selectedTab = index;
    this.activeLink = linkPath;

    const selectedLink = this.data.sblinks[index];

    if (selectedLink) {
        this.currentTutorialModule = selectedLink.name;

        console.log("Selected Tutorial Module:", this.currentTutorialModule);
    }

    this.$router.push(this.parentUrl + linkPath);
},
        back() {
            this.$router.replace("/dummy").then(() => {
                this.$router.replace("/home");
                this.syncDrawerState(); // Force update after route change
            });
        },
        openTutorial() {

            const key =
                `${this.userType}_${this.currentModule}`;

            console.log("================================");
            console.log("User Type:", this.userType);
            console.log("Current Module:", this.currentModule);
            console.log("Tutorial Key:", key);
            console.log("Tutorial:", this.tutorials[key]);
            console.log("================================");

            const tutorial = this.tutorials[key];

            if (tutorial) {

                this.youtubeUrl = tutorial.url;
                this.tutorialTitle = tutorial.title;
                this.videoDialog = true;

            } else {

                console.log("No tutorial found for:", key);

            }
        },
        initializeRoleData() {
            try {
                const storedRoles = sessionStorage.getItem("emp_role");
                this.emp_roles = storedRoles ? JSON.parse(storedRoles) : {};
            } catch (error) {
                console.error("Error parsing emp_role from sessionStorage:", error);
                this.emp_roles = {};
            }
        },
        setupNavigation() {
            this.items = [{ text: "Home", disabled: false, href: "/home-updated" }];
            if (Array.isArray(this.emp_roles.children) && this.emp_roles.children.length > 1) {
                const uniqueRoleTypes = [...new Set(this.emp_roles.children.map(role => role.para_role_type))];
                if (uniqueRoleTypes.length === 1 && this.emp_roles.name === uniqueRoleTypes[0]) {
                    this.items.push({
                        text: this.emp_roles.name,
                        disabled: false,
                        href: "/emp-role-dashboard",
                    });
                } else {
                    const roleNames = this.emp_roles.children.map(role => role.name).join(", ");
                    this.items.push({
                        text: roleNames,
                        disabled: false,
                        href: "/emp-role-dashboard",
                    });
                }
            } else if (this.emp_roles.para_role_type) {
                this.items.push({
                    text: this.emp_roles.para_role_type,
                    disabled: true,
                    href: "",
                });
            }
            this.items.push({
                text: this.local_role_name,
                disabled: true,
                href: "/role-dashboard",
            });

            this.module_name = this.local_role_type;
        },
        fetchSidebarLinks() {
            if (!this.local_role_type) {
                console.warn("No role type found, skipping sidebar fetch.");
                return;
            }

            this.load = false;
            this.data = { sblinks: [] };

            const isDirectURL = !document.referrer;
            const navType = performance.getEntriesByType("navigation")[0].type;
            const isDirectPaste = isDirectURL && navType === "navigate";

            axios.post("/home/sidebar_links", {
                role_type: this.local_role_type,
                role_name: this.local_role_name,
            }).then((res) => {
                if (res.data.msg === "200") {
                  this.is_admin = String(res.data.is_admin).toLowerCase() === "true";
                    sessionStorage.removeItem("sblinks");
                    const currentPath = this.$route.path;

                    if(currentPath!='/emp-role-dashboard'){
                    this.data.sblinks = res.data.sblinks;
                    //  if (!isDirectPaste) {
                    //      this.data.sblinks = res.data.sblinks;
                    //  }
                    this.show_link_order = res.data.show_link_order;
                    this.parentUrl = "/role-dashboard";
                    }

                    // if (Array.isArray(res.data.sblinks) && !isDirectPaste) {
                    //     sessionStorage.setItem("sblinks", JSON.stringify(res.data.sblinks));
                    // }
                    if (Array.isArray(res.data.sblinks)) {
                        sessionStorage.setItem("sblinks", JSON.stringify(res.data.sblinks));
                    }

                    const sblinks = res.data.sblinks || [];
                    if (sblinks.length === 1 && this.$route.path === "/role-dashboard") {
                        const target = "/role-dashboard" + sblinks[0].link;
                        this.$router.push(target);
                        return;
                    }

                    this.learner_standard = res.data.current_standard_code;
                    this.learner_board = res.data.board;
                    this.learner_courses = res.data.courses;

                    sessionStorage.setItem("learner_standard",this.learner_standard)
                    sessionStorage.setItem("learner_board",this.learner_board)
                    const codes = this.learner_courses.map(item => item.code);
                    sessionStorage.setItem("learner_courses", JSON.stringify(codes));
                    this.load = true;
                } else {
                    console.error("Unexpected API response:", res.data);
                }
            }).catch((error) => {
                console.error("Error fetching sidebar links:", error);
                this.load = true;
            });
        },
    },
    watch: {
        
        "$route": {
            handler(to, from) {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                console.log("Route changed from:", from.fullPath, "to:", to.fullPath);
                // this.local_role_name = to.params.role_name || sessionStorage.getItem("para_role") || "";
                // this.local_role_type = to.params.role_type || sessionStorage.getItem("para_role_type") || "";
                this.local_role_name =
    to.query.role_name ||
    sessionStorage.getItem("para_role") ||
    "";

this.local_role_type =
    to.query.role_type ||
    sessionStorage.getItem("para_role_type") ||
    "";
                this.fetchSidebarLinks();
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
       window.scrollTo({ top: 0, behavior: "smooth" });
         sessionStorage.removeItem("sblinks");
        this.initializeRoleData();
        // this.setupNavigation();
        if (this.local_role_type) {
            this.fetchSidebarLinks();
        } else {
            console.warn("Role type is missing, fetching links may not work correctly.");
        }
        sessionStorage.setItem("master-data", "false");
        // sessionStorage.removeItem("master_module_name");
        const isMasterPage = this.$route.path.includes("-master");
        if (!isMasterPage) {
            sessionStorage.setItem("master-data", "false");
            sessionStorage.removeItem("master_module_name");
        }
    },
  
};
</script>
<style scoped>
@media print {
    .no-print,
    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }
}

.tab-toggle-card {
    padding: 16px;
    border: 1px solid #dcdcdc;
    border-radius: 12px;
    background-color: var(--v-brandLight-base);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    /* margin-bottom: 16px; */
}
.tab-toggle.active .v-avatar {
  background-color: white;
  padding: 2px;
  border-radius: 50%; /* ensures it's circular */
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.15); /* optional subtle shadow */
}

.tab-toggle-inner {
    display: flex;
    flex-wrap: wrap;
    /* Allow wrapping to new lines */
    gap: 12px;
}

.tab-toggle {
    display: inline-flex;
    align-items: center;
    padding: 8px 16px;
    border-radius: 10px;
    background-color: white;
    color: #023e8a;
    font-weight: 600;
    border: 1px solid #023e8a;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
}

.tab-toggle:hover {
    background: linear-gradient(
        135deg,
        var(--v-brand-base),
        color-mix(in srgb, var(--v-brand-base) 85%, var(--v-brandLight-base))
    );
    color: white;
}

.tab-toggle.active {
    background: linear-gradient(
        135deg,
        var(--v-brand-base),
        color-mix(in srgb, var(--v-brand-base) 75%, var(--v-brandLight-base))
    );
    color: white;
    box-shadow: 0 0 6px color-mix(
        in srgb,
        var(--v-brand-base) 70%,
        var(--v-brandLight-base)
    );
    border: none;
}

.tab-toggle.active:hover {
    background: linear-gradient(
        135deg,
        color-mix(in srgb, var(--v-brand-base) 90%, var(--v-brandLight-base)),
        color-mix(in srgb, var(--v-brand-base) 65%, var(--v-brandLight-base))
    );
    box-shadow: 0 6px 18px color-mix(
        in srgb,
        var(--v-brand-base) 60%,
        var(--v-brandLight-base)
    );
}
</style>